import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  ActiveFilterChip,
  FilterResult,
  FiltersConfig,
} from '../../models/filter.interface';
import { PaChipComponent } from '../../ui-kit/pa-chip/pa-chip.component';
import { buildActiveFilterChipsFromConfig } from '../../helpers/filter-chip.helper';

@Component({
  selector: 'app-chip-filters',
  standalone: true,
  imports: [CommonModule, PaChipComponent],
  templateUrl: './chip-filters.component.html',
  styleUrls: ['./chip-filters.component.scss'],
})
export class ChipFiltersComponent implements OnChanges {
  @Input() filtersConfig: FiltersConfig | null = null;
  @Input() filterResult: FilterResult | null = null;
  @Input() removable = false;

  @Output() remove = new EventEmitter<string>();
  @Output() chipClick = new EventEmitter<string>();

  chips: ActiveFilterChip[] = [];

  ngOnChanges(): void {
    if (!this.filtersConfig || !this.filterResult) {
      this.chips = [];
      return;
    }

    this.chips = buildActiveFilterChipsFromConfig(
      this.filtersConfig,
      this.filterResult,
    );
  }

  isChipRemovable(chip: ActiveFilterChip): boolean {
    if (!this.removable) {
      return false;
    }

    if (chip.required) {
      return false;
    }

    return true;
  }

  trackByKey(_index: number, chip: ActiveFilterChip): string {
    return chip.key;
  }

  handleRemove(key: string): void {
    this.remove.emit(key);
  }

  handleClick(key: string): void {
    this.chipClick.emit(key);
  }
}

